import React, { useEffect, useState } from 'react';
import { api } from './api';

//Bootstrap styles
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import Stack from 'react-bootstrap/Stack';

export default function App() {
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState('');
  const [due, setDue] = useState('');
  const [status, setStatus] = useState('');
  const [tz, setTz] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [initInfo, setInitInfo] = useState({ present: false, len: 0 });

  useEffect(() => {
    if (window.Telegram?.WebApp) {
      try { window.Telegram.WebApp.ready(); } catch(e) {}
    }
    // отправим таймзону и загрузим задачи
    (async () => {
      // collect initData presence for debugging (do not log value)
      try {
        const init = window.Telegram?.WebApp?.initData;
        setInitInfo({ present: !!init, len: init ? init.length : 0 });
      } catch (e) {}
      try {
        await api.setTimezone(tz);
      } catch (e) {
        console.warn('setTimezone error', e.message);
      }
      await load();
    })();
    // eslint-disable-next-line
  }, []);

  async function load() {
    setStatus('Загрузка...');
    try {
      const data = await api.getTasks();
      setTasks(data);
      setStatus('');
    } catch (e) {
      setStatus('Ошибка: ' + e.message);
    }
  }

  async function create() {
    if (!title || !due) {
      setStatus('Укажи название и дату/время');
      return;
    }
    try {
      await api.createTask(title, due);
      setTitle('');
      setDue('');
      await load();
      setStatus('✅ Задача создана');
    } catch (e) {
      setStatus('Ошибка: ' + e.message);
    }
  }

  async function complete(id) {
    try {
      await api.completeTask(id);
      await load();
    } catch (e) {
      setStatus('Ошибка: ' + e.message);
    }
  }

  async function deleteTask(id) {
    if (!window.confirm('Удалить задачу?')) return;
    
    try {
      await api.deleteTask(id);
      setStatus('✅ Задача удалена');
      await load();
    } catch (e) {
      setStatus('Ошибка: ' + e.message);
    }
  }

  return (
    <Container>
      <Row className="justify-content-center text-center mt-3">
        <h2>Мои задачи</h2>
      </Row>
      <Row className="justify-content-center mb-3">
        <Form>
          <Form.Group controlId="formBasicEmail">          
            <Stack gap={2} className="col-md-5 mx-auto">
              <Form.Control type="text" placeholder="Название задачи" value={title} onChange={e => setTitle(e.target.value)}/>
              <Form.Control type="datetime-local" value={due} onChange={e => setDue(e.target.value)}/>
              <Form.Check type="switch" id="repeat" label="Повторяемое событие"/>          
              <Button variant="primary" type="submit" onClick={create} className="justify-content-center text-center">
                Создать
              </Button>
            </Stack>
          </Form.Group>
        </Form>
      </Row>
      <Row className="justify-content-center text-center">
      </Row>
      <Row>
        <hr style={{ margin: '16px 0' }} />
      </Row>
      <div style={{ padding: 16, fontFamily: 'system-ui, Arial', maxWidth: 540, margin: '0 auto' }}>
        {status && <div style={{ marginBottom: 8 }}>{status}</div>}

        <ul style={{ listStyle: 'none', padding: 0 }}>
          {tasks.map(t => (
            <li key={t.id} style={{
              padding: 12,
              border: '1px solid #ddd',
              borderRadius: 8,
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <div style={{ fontWeight: 600 }}>
                  {t.title} {t.completed ? '✅' : ''}
                </div>
                <div style={{ fontSize: 12, opacity: 0.8 }}>
                  {new Date(t.due_time).toLocaleString()}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                {!t.completed && (
                  <button 
                    onClick={() => complete(t.id)}
                    style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      border: '1px solid #ddd'
                    }}
                  >
                    Готово
                  </button>
                )}
                <button 
                  onClick={() => deleteTask(t.id)}
                  style={{ 
                    backgroundColor: '#ff4444',
                    color: 'white',
                    border: 'none',
                    padding: '4px 8px',
                    borderRadius: 4
                  }}
                >
                  Удалить
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  );
}